import React from "react";
interface Step {
  label: string;
  status: string;
  icon: string;
}
interface MultiStepperProps {
  steps: Step[];
}

const MultiStepper: React.FC<MultiStepperProps> = ({ steps = [] }) => {
  return (
    <div
      style={{
        width: "100%",
        padding: "10px 0",
        background: "#f8f9fb",
        borderRadius: "6px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "8px 12px",
        }}
      >
        {steps.map((step, index) => {
          const isCompleted = step.status === "Completed";
          const isActive = step.status === "In Progress";

          return (
            <React.Fragment key={index}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  color: isActive
                    ? "#1976d2"
                    : isCompleted
                    ? "#1976d2"
                    : "#6c757d",
                  fontWeight: 400,
                  fontSize: "14px",
                  cursor: "default",
                }}
              >
                <span className="material-icons">
                  {step.icon}
                </span>
                {step.label}
              </div>

              {index !== steps.length - 1 && (
                <span
                  className="material-icons"
                  style={{
                    fontSize: "18px",
                    margin: "0 8px",
                    color: "#c0c4cc",
                  }}
                >
                  chevron_right
                </span>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default MultiStepper;